import { Component, type ReactNode } from "react";

import { track } from "utilities/analytics/analytics";

import { BTButtonDeprecated } from "commonComponents/btWrappers/BTButtonDeprecated/BTButtonDeprecated";
import { BTCard } from "commonComponents/btWrappers/BTCard/BTCard";
import { BTTitle } from "commonComponents/btWrappers/BTTitle/BTTitle";
import DismissButton from "commonComponents/entity/emptyState/common/DismissButton/DismissButton";
import {
    type EmptyStateActions,
    EmptyStateDataType,
    type IEmptyStateBannerOnlyEntityProps,
} from "commonComponents/entity/emptyState/common/EmptyState.api.types";
import {
    getEmptyStateDataType,
    type IEmptyStateProps,
} from "commonComponents/entity/emptyState/EmptyState";

import "./EmptyStateBanner.less";

export interface IEmptyStateBannerProps extends IEmptyStateProps {
    children?: ReactNode;
    actionBeingPerformed?: EmptyStateActions;
    isDismissable?: boolean;
    onDismiss?: () => void;
    bordered?: boolean;
}

class EmptyStateBannerBase extends Component<IEmptyStateBannerProps> {
    render() {
        const { title, children, image, onDismiss, isDismissable, bordered, className } =
            this.props;
        return (
            <BTCard className={`EmptyStateBanner ${className}`} bordered={bordered}>
                <div className="BannerContent" data-testid={this.props["data-testid"]}>
                    {image && <div className="BannerImage">{image}</div>}
                    <div>
                        <BTTitle level={3} data-testid="empty-state-banner-title">
                            {title}
                        </BTTitle>
                        <div className="BannerBody" data-testid="empty-state-banner-body">
                            {children}
                        </div>
                        {isDismissable && (
                            <DismissButton
                                onDismiss={onDismiss}
                                actionBeingPerformed={this.props.actionBeingPerformed}
                            />
                        )}
                    </div>
                </div>
            </BTCard>
        );
    }
}

export const EmptyStateBanner = track((props) => ({
    component: "Empty State Banner",
    uniqueId: props.title,
}))(EmptyStateBannerBase);

export function getEmptyStateBannerOnlyEntityDataType(props: IEmptyStateBannerOnlyEntityProps) {
    if (props.hasListData) {
        if (props.isNewToEntity) {
            return EmptyStateDataType.InitialWithDataState;
        }
    } else {
        return getEmptyStateDataType(props);
    }

    return null;
}

interface IEmptyStateCallToActionButton {
    onCallToActionClick: () => void;
    disabled?: boolean;
    children?: React.ReactNode;
}
export const EmptyStateCallToActionButton = (props: IEmptyStateCallToActionButton) => (
    <BTButtonDeprecated
        disabled={props.disabled}
        data-testid="emptyStateBannerNew"
        className="padding-horizontal-xs"
        loadingAction="new"
        actionBeingPerformed={undefined}
        type="link"
        onClick={props.onCallToActionClick}
    >
        <strong>{props.children}</strong>
    </BTButtonDeprecated>
);
